import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";

const Toast = ({
  message,
  type = "success",
  duration = 5000,
  position = "bottom-right",
  onClose,
}) => {
  const [isVisible, setIsVisible] = useState(true);
  
  // Auto-close after duration
  useEffect(() => {
    if (duration) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => {
          onClose && onClose();
        }, 300); // Allow time for exit animation
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);
  
  // Handle manual close
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose && onClose();
    }, 300); // Allow time for exit animation
  };
  
  // Type configurations
  const typeConfig = {
    success: {
      icon: "CheckCircle",
      bgColor: "bg-success bg-opacity-10",
      borderColor: "border-success",
      textColor: "text-success",
      iconColor: "text-success",
    },
    error: {
      icon: "XCircle",
      bgColor: "bg-error bg-opacity-10",
      borderColor: "border-error",
      textColor: "text-error",
      iconColor: "text-error",
    },
    warning: {
      icon: "AlertTriangle",
      bgColor: "bg-warning bg-opacity-10",
      borderColor: "border-warning",
      textColor: "text-warning",
      iconColor: "text-warning",
    },
    info: {
      icon: "Info",
      bgColor: "bg-info bg-opacity-10",
      borderColor: "border-info",
      textColor: "text-info",
      iconColor: "text-info",
    },
  };
  
  const config = typeConfig[type] || typeConfig.info;
  
  // Position styles
  const positionStyles = {
    "top-right": "top-4 right-4",
    "top-left": "top-4 left-4",
    "bottom-right": "bottom-4 right-4",
    "bottom-left": "bottom-4 left-4",
    "top-center": "top-4 left-1/2 transform -translate-x-1/2",
    "bottom-center": "bottom-4 left-1/2 transform -translate-x-1/2",
  };
  
  return (
    <div
      className={`
        fixed z-50 ${positionStyles[position] || positionStyles["bottom-right"]}
        transition-all duration-300 ease-in-out
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}
      `}
      role="alert"
      aria-live="assertive"
    >
      <div className={`
        max-w-sm w-full shadow-lg rounded-lg pointer-events-auto
        border-l-4 ${config.borderColor}
        ${config.bgColor} p-4
      `}>
        <div className="flex items-start">
          <div className={`flex-shrink-0 ${config.iconColor}`}>
            <Icon name={config.icon} size={20} />
          </div>
          <div className="ml-3 w-0 flex-1">
            <p className={`text-sm font-medium ${config.textColor}`}>
              {message}
            </p>
          </div>
          <div className="ml-4 flex-shrink-0 flex">
            <button
              className="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 rounded-md"
              onClick={handleClose}
            >
              <span className="sr-only">Close</span>
              <Icon name="X" size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;